module.exports = __webpack_public_path__ + "img/goods01.17e57b50.jpg";